<template>
  <div class="">
    <div class="label-standard">
      <RequiredAsterisk />
      Employment status
    </div>

    <div class="form-line">
      <select class="select-standard"
        :value="value == null ? -1 : value"
        v-on:change="updateValue({
          objectType: 'employment',
          index     : index,
          key       : 'status',
          value     : $event.target.value,
        })">
        <option value="-1" disabled="">Select an option...</option>
        <option value="0">Full Time</option>
        <option value="1">Part Time</option>
        <option value="2">Contractor</option>
        <option value="11">Casual</option>
        <option value="3">Temp</option>
        <option value="12">Commission</option>
        <option value="13">Seasonal</option>
        <option value="4">Self Employed</option>
        <option value="5">Home Duties</option>
        <option value="6">Retired</option>
        <option value="7">Student</option>
        <option value="8">Not Employed</option>
        <option value="9">Government Benefits</option>
        <option value="10">Other</option>
      </select>
    </div>
  </div>
</template>

<script>
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      value : {
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },
    },

    components : {
      RequiredAsterisk
    },
  }
</script>